export const LOAD_INTERNAL_MARKETER = 'LOAD_INTERNAL_MARKETER';
export type LOAD_INTERNAL_MARKETER = typeof LOAD_INTERNAL_MARKETER;

export interface LoadInternalMarketer {
    type: LOAD_INTERNAL_MARKETER;
    id: string;
}

export function loadInternalMarketerAction(id: string): LoadInternalMarketer {
    return {
        type: LOAD_INTERNAL_MARKETER,
        id
    };
}
